<div class="dialog-container">
    <div class="dialog-header">
        <div class="close-dialog">
            <button
                mat-icon-button
                mat-dialog-close
                class="button-close--outlined"
                color="primary"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <h1 mat-dialog-title class="modal-title">Cambio Password</h1>
    </div>

    <div mat-dialog-content>
        <form (ngSubmit)="onYesClick()" [formGroup]="formGroup">
            <mat-dialog-content>
                <mat-form-field>
                    <input
                        matInput
                        type="password"
                        placeholder="Vecchia Password"
                        formControlName="old_password"
                        required
                    />
                    <mat-icon matSuffix>vpn_key</mat-icon>
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['old_password'].hasError('required')"
                        >La vecchia password è obbligatoria</mat-error
                    >
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['old_password'].hasError('whiteSpace')"
                        >Gli spazi non sono ammessi</mat-error
                    >
                </mat-form-field>
                <mat-form-field>
                    <input
                        matInput
                        type="password"
                        placeholder="Nuova Password"
                        formControlName="new_password"
                        required
                    />
                    <mat-icon matSuffix>vpn_key</mat-icon>
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['new_password'].hasError('policyNotMatch')"
                        >Lunga 10 con una minuscola, una maiuscola, un numero e un
                        simbolo</mat-error
                    >
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['new_password'].hasError('required')"
                        >La nuova password è obbligatoria</mat-error
                    >
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['new_password'].hasError('whiteSpace')"
                        >Gli spazi non sono ammessi</mat-error
                    >
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['new_password'].hasError('passwordMatch')"
                        >Le password devono corrispondere</mat-error
                    >
                </mat-form-field>
                <mat-form-field>
                    <input
                        matInput
                        type="password"
                        placeholder="Conferma Nuova Password"
                        formControlName="confirm_password"
                        required
                    />
                    <mat-icon matSuffix>vpn_key</mat-icon>
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['confirm_password'].hasError('required')"
                        >La conferma della password è obbligatoria</mat-error
                    >
                    <mat-error
                        class="error-message"
                        *ngIf="formGroup.controls['confirm_password'].hasError('passwordMatch')"
                        >Le password devono corrispondere</mat-error
                    >
                </mat-form-field>
            </mat-dialog-content>
            <mat-dialog-actions class="form__footer">
                <button
                    mat-raised-button
                    class="col-6"
                    type="submit"
                    color="accent"
                    [disabled]="!formGroup.valid"
                >
                    Salva
                </button>
            </mat-dialog-actions>
        </form>
    </div>
</div>
